import {createRoot, hydrateRoot} from 'react-dom/client';
import SelectedToursGridArchitecture from '../pages/SelectedToursGridArchitecture/SelectedToursGridArchitecture'
import "../index.css";
import "../pages/SelectedToursGridArchitecture/SelectedToursGridArchitecture.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<SelectedToursGridArchitecture {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <SelectedToursGridArchitecture {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).SelectedToursGridArchitectureVC = {mount, hydrate, unmount}